import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RewardsService } from '../../services/reward.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { CategoriesActions } from '../actions/categories.action';

@Injectable()
export class CategoriesEffects {
  private actions$ = inject(Actions);
  private api = inject(RewardsService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoriesActions.loadCategories),
      switchMap(() =>
        this.api.fetchCategories().pipe(
          map((data) => CategoriesActions.loadCategoriesSuccess({ data })),
          catchError((err) =>
            of(CategoriesActions.loadCategoriesFailure({ error: err?.message ?? 'Failed to load Categories' }))
          )
        )
      )
    )
  );
}
